import React, { createContext, useContext, useState } from "react";
import {
  getCompanySalaryApprovalsV2,
  getSalaryApprovalsByApproverV2,
} from "../api/timesheetApi";

const PendingSalaryApprovalsContext = createContext();

export function PendingSalaryApprovalsProvider({ children }) {
  const [pendingSalaryApprovalsCount, setPendingSalaryApprovalsCount] = useState(0);

  const updatePendingSalaryApprovalsCount = async (userData) => {
    if (!userData?.id) {
      setPendingSalaryApprovalsCount(0);
      return;
    }

    try {
      // Для директора считаем pending company approvals.
      if (Number(userData.id) === 41) {
        const companyApprovals = await getCompanySalaryApprovalsV2();
        const pendingCompanyApprovals =
          (companyApprovals || []).filter((item) => {
            const status = String(item?.status || "").toLowerCase();
            return status === "pending" || status === "на рассмотрении";
          }) || [];
        setPendingSalaryApprovalsCount(pendingCompanyApprovals.length);
        return;
      }

      // Для остальных считаем только те согласования, где есть pending шаг текущего пользователя.
      const approvals = await getSalaryApprovalsByApproverV2(userData.id);
      const pendingApprovals =
        (approvals || []).filter((approval) => {
          const userStep = (approval.steps || []).find(
            (step) => Number(step?.approver?.id) === Number(userData.id),
          );
          if (!userStep) return false;
          const status = String(userStep.status || "").toLowerCase();
          return status === "pending" || status === "на рассмотрении";
        }) || [];

      setPendingSalaryApprovalsCount(pendingApprovals.length);
    } catch (error) {
      console.debug("Нет зарплатных согласований в ожидании");
      setPendingSalaryApprovalsCount(0);
    }
  };

  return (
    <PendingSalaryApprovalsContext.Provider
      value={{
        pendingSalaryApprovalsCount,
        updatePendingSalaryApprovalsCount,
      }}
    >
      {children}
    </PendingSalaryApprovalsContext.Provider>
  );
}

export const usePendingSalaryApprovals = () =>
  useContext(PendingSalaryApprovalsContext);
